import Vue from 'vue'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'

Vue.use(firestorePlugin)
let db = null

/**
 * firebaseを初期化する
 */
async function init () {
  let firebaseApp = null
  let firebaseConfig = null
  if (process.env.NODE_ENV === 'production') {
    const response = await fetch('/__/firebase/init.json')
    firebaseConfig = await response.json()
  } else {
    firebaseConfig = {
      apiKey: 'AIzaSyD-3E2A7rT1DV8DuOi32J15WT5E4NuTkCw',
      authDomain: 'diary-4735a.firebaseapp.com',
      databaseURL: 'https://diary-4735a.firebaseio.com',
      projectId: 'diary-4735a',
      storageBucket: 'diary-4735a.appspot.com',
      messagingSenderId: '1039305563679',
      appId: '1:1039305563679:web:6739e646f9372984077f2a',
      measurementId: 'G-HLKTZM37YR'
    }
  }
  firebaseApp = firebase.initializeApp(firebaseConfig)
  firebase.firestore().enablePersistence({synchronizeTabs: true})
  db = firebaseApp.firestore()
}

export default {init}
export {db}



// WEBPACK FOOTER //
// ./src/plugins/firestore.js